import styled from "styled-components";
import { ElementGroup, Title } from "styles/components";
import { PopupType } from "../PopupType";
import { useAbsPopupButton, usePopupData } from "commons/popup/store/absPopupHook";
import Button from "components/ui/Button";
import { ButtonType } from "components/ComponentsType";
import AbsPopup from "commons/popup/display/AbsPopup";
import { ButtonState } from "commons/popup/store/absPopupVo";
import { usePaymentPopupInit } from "./PaymentPopupHook";
import useAuth from "store/modules/auth/authHook";

const TitleDiv = styled.div`
  width: 100%;
  padding: 10px 16px;
  height: 40px;
  h3 {
    margin-bottom: 0;
    font-size: 18px;
    text-align: center;
  }
  button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 7px 20px;
    border: none;
  }
`;

const ContentDiv = styled.div`
  /* padding: 10px; */
  /* background-color: #e3e3e3; */
  div {
    width: 100%;
  }
  > div {
    width: 100%;
    margin: 10px 0;
    background-color: #f0f0f0;
    box-shadow: 2px 4px 4px #ebebeb;
    border-radius: 5px;
    padding: 5px 10px;
    > div span:last-child {
      color: var(--font-sub-grey);
      &.total-count {
        /* font-weight: bold; */
        color: var(--font-red);
        font-size: 1.05rem;
      }
    }
    p {
      width: 100%;
      font-weight: 700;
      text-align: left;
    }
  }
`;
const Footer = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 10px;

  Button {
    width: 30%;
  }
`;
function PopupHeader() {
  return (
    <TitleDiv>
      <Title weight="bold" mgTop={5}>
        정산 내역
      </Title>
    </TitleDiv>
  );
}
export function FooterButton() {
  const { close } = useAbsPopupButton(PopupType.PAYMENT_POPUP);
  return (
    <Footer>
      <Button text="확인" thin btnSize={"sm"} btnType={ButtonType.NORMAL} onClick={close.bind(null, ButtonState.NO)} />
    </Footer>
  );
}

export default function PaymentPopup(): JSX.Element {
  const { popupDo } = usePopupData<number>(PopupType.PAYMENT_POPUP);
  const { data } = usePaymentPopupInit(popupDo.data!);
  const { service_type } = useAuth();
  const detail = data[0].detail;
  const month = data[0].pre_month.substring(5, 7);

  const numberComma = (num: number) => {
    return num.toLocaleString("ko-kr");
  };

  return (
    <AbsPopup type={PopupType.PAYMENT_POPUP} borderShape={4} header={<PopupHeader />}>
      <ContentDiv>
        {data[0].revenue > 0 ? (
          <>
            {detail?.contents &&
              service_type?.includes("PROVIDER") &&
              (detail.contents.view_us !== 0 || detail.contents.msn !== 0) && (
                <ElementGroup.Col>
                  <p>콘텐츠 서비스</p>
                  <ElementGroup.Col>
                    {detail.contents.view_us ? (
                      <ElementGroup.Row flexContent="between">
                        <span>뷰어스 : {numberComma(detail.contents.view_us)}</span>
                        <span>{month}월 정산분</span>
                      </ElementGroup.Row>
                    ) : (
                      <></>
                    )}
                    {detail.contents.msn ? (
                      <ElementGroup.Row flexContent="between">
                        <span>MSN : {numberComma(detail.contents.msn)}</span>
                        <span>{data[0].msn_pre_month.substring(5, 7)}월 정산분</span>
                      </ElementGroup.Row>
                    ) : (
                      <></>
                    )}
                  </ElementGroup.Col>
                </ElementGroup.Col>
              )}

            {detail?.media && service_type?.includes("MEDIA") && detail.media.youtube! > 0 && (
              <ElementGroup.Col>
                <p>음원/영상 서비스</p>
                <ElementGroup.Col>
                  <ElementGroup.Row flexContent="between">
                    <span>유튜브 : {numberComma(detail.media.youtube!)}</span>
                    <span>{month}월 정산분</span>
                  </ElementGroup.Row>
                </ElementGroup.Col>
              </ElementGroup.Col>
            )}

            {detail?.partners && service_type?.includes("PARTNERS") && detail.partners.view_us! > 0 && (
              <ElementGroup.Col>
                <p>파트너스 서비스</p>

                <ElementGroup.Col>
                  <ElementGroup.Row flexContent="between">
                    <span>뷰어스 : {numberComma(detail.partners.view_us!)}</span>
                    <span>{month}월 정산분</span>
                  </ElementGroup.Row>
                </ElementGroup.Col>
              </ElementGroup.Col>
            )}

            <ElementGroup.Col>
              <ElementGroup.Row flexContent="between">
                <span>총 합계</span>
                <span className="total-count">{numberComma(data[0].revenue)}</span>
              </ElementGroup.Row>
            </ElementGroup.Col>
          </>
        ) : (
          <p style={{ textAlign: "center" }}>지급 내역이 없습니다.</p>
        )}
      </ContentDiv>
    </AbsPopup>
  );
}
